/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect } from 'react';

const OfflineFallback = props => {

    useEffect(()=>{
        document.getElementById("root").firstElementChild.classList.value = "w-100 h-100";
        return () => document.getElementById("root").firstElementChild.classList.value = "";
    },[])

    return (
        <div className="w-100 h-100 text-center">
            {/* <span><i className="fa fas-wifi"></i></span><br /> */}
            <h1 className="my-auto" style={{ fontSize: "2rem" }}><br />Please check your internet connectivity</h1>
        </div>
    )
}
export default OfflineFallback;
